import { Space, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import { PrinterPrintJobRow } from '../hooks/use-printer-print-jobs'

export const columns: ColumnsType<PrinterPrintJobRow> = [
    {
        dataIndex: 'clientName',
        title: 'Клиент',
    },
    {
        dataIndex: 'shipmentId',
        title: 'Номер тиража',
        width: 120,
    },
    {
        key: 'dates',
        title: 'Дата',
        width: 160,
        render: (_, record) => (
            <Space direction='vertical' size={0}>
                <Typography.Text>{renderDatetime(record.start)}</Typography.Text>
                {record.end && (
                    <Typography.Text type='secondary'>
                        → {renderDatetime(record.end)}
                    </Typography.Text>
                )}
            </Space>
        ),
    },
]
